import styled, { css } from 'styled-components';
import { H4 } from 'components/Typography';
import Button from 'components/Button';
import { th } from 'style/theme';
import { sizes } from 'style';

export const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: max-content;
`;

export const SubHeading = styled(H4)`
  margin-bottom: 20px;
`;

export const RatingSelection = styled.div`
  margin-bottom: 40px;
`;

export const HelpTexts = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Why = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 160px;
  border: none;
  font-family: ${th('fonts.body')};
  font-size: 16px;
`;

export const SmallTextArea = styled.textarea`
  width: 100%;
  height: 40px;
  border: none;
  font-family: ${th('fonts.body')};
  font-size: 16px;
`;

export const NextButton = styled(Button)`
  display: block;
  align-self: flex-end;
  margin-top: 20px;
`;

export const RadioButton = styled.input`
  position: relative;
  margin: 65px 30px 24px 30px;

  @media ${sizes.tabletPortrait} {
    margin: 85px 40px 24px 40px;
  }

  ${({ $image }) =>
    $image &&
    css`
      ::before {
        content: ' ';
        background-image: url(${$image});
        width: 60px;
        height: 52px;
        background-size: 100%;
        background-repeat: no-repeat;
        position: absolute;
        top: -55px;
        left: -25px;
        color: ${({ $color }) => $color};
        font-weight: bold;
        opacity: 0.5;

        @media ${sizes.tabletPortrait} {
          width: 75px;
          height: 60px;
          top: -65px;
          left: -30px;
        }
      }
    `};

  :checked {
    ::before {
      opacity: 1;
    }
  }

  ${({ value }) =>
    typeof value !== 'undefined' &&
    css`
      ::after {
        content: '${value}';
        position: absolute;
        bottom: -25px;
        left: 50%;
        transform: translateX(-50%);
        color: ${({ $color }) => $color};
        font-weight: bold;
      }
    `};
`;
